(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["caterers-restaurants"] && !Shopify.designMode) return;
  try {
    
function focusCateringConfirmation() {
  document.querySelectorAll('[data-catering-confirmation]').forEach(root => {
    if (root.dataset.confirmationFocused) return;
    root.dataset.confirmationFocused = 'true';
    root.querySelector('h1').focus({ preventScroll: true });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', focusCateringConfirmation);
else focusCateringConfirmation();
document.addEventListener('shopify:section:load', focusCateringConfirmation);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["corporate-gifts-enhanced"] && !Shopify.designMode) return;
  try {
    
// Google Ads: Corporate Gift - Lead, supplied by Jake Renter on October 5, 2026.
function initCorporateQuoteTracking(root) {
  const form = root.querySelector('form[id^="CorporateGiftForm-"]');
  if (root.dataset.corporateTrackingInitialized || (!form && !root.hasAttribute('data-corporate-confirmation'))) return;
  root.dataset.corporateTrackingInitialized = 'true';
  if (form) form.dataset.corporateTrackingInitialized = 'true';
  const storageKey = 'mln-corporate-quote-pending';
  const confirmation = root.querySelector('[data-corporate-quote-success]');
  const successful = Boolean(confirmation);
  if (confirmation) confirmation.focus({ preventScroll: true });
  const maxAge = 30 * 60 * 1000;
  let pending = null;

  try {
    pending = JSON.parse(window.sessionStorage.getItem(storageKey));
    if (!successful || !pending || typeof pending.id !== 'string' ||
        !Number.isFinite(pending.at) || Date.now() - pending.at > maxAge ||
        pending.at > Date.now()) {
      window.sessionStorage.removeItem(storageKey);
      pending = null;
    }
  } catch (_) { pending = null; }

  // This records an attempt only. The conversion waits for Shopify's success response.
  if (form) form.addEventListener('submit', () => {
    const id = window.crypto && typeof window.crypto.randomUUID === 'function'
      ? window.crypto.randomUUID()
      : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify({ id: id, at: Date.now() }));
    } catch (_) { /* Tracking must never prevent the quote request. */ }
  });

  let sent = false;
  function trackIfAllowed() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== 'function' || !privacy.marketingAllowed()) return;

    // The storefront's Google & YouTube pixel runs in a sandbox. Load a page tag
    // when needed so this form's conversion can reach Jake's Google Ads account.
    if (!window.__mlnCorporateGoogleTagConfigured) {
      window.dataLayer = window.dataLayer || [];
      if (typeof window.gtag !== 'function') {
        window.gtag = function () { window.dataLayer.push(arguments); };
        window.gtag('js', new Date());
      }
      window.gtag('config', 'AW-1001837381', {
        send_page_view: false,
        allow_ad_personalization_signals: typeof privacy.saleOfDataAllowed === 'function'
          ? privacy.saleOfDataAllowed() : false
      });
      if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
        const tag = document.createElement('script');
        tag.async = true;
        tag.src = 'https://www.googletagmanager.com/gtag/js?id=AW-1001837381';
        document.head.appendChild(tag);
      }
      window.__mlnCorporateGoogleTagConfigured = true;
    }

    if (!successful || !pending || sent || Date.now() - pending.at > maxAge) return;
    // Consume the attempt before dispatch so reloads and consent updates cannot
    // count the same quote again. No form field values are sent to Google.
    sent = true;
    try { window.sessionStorage.removeItem(storageKey); } catch (_) {}
    window.gtag('event', 'conversion', {
      send_to: 'AW-1001837381/EANhCIG4_pEdEMWm290D',
      transaction_id: pending.id
    });
  }

  document.addEventListener('visitorConsentCollected', trackIfAllowed);
  if (window.Shopify && window.Shopify.customerPrivacy) {
    trackIfAllowed();
  } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error) trackIfAllowed();
    });
  }
}

function initCorporateGifts(root) {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  initCorporateQuoteTracking(root);
  root.querySelectorAll('[data-gift]').forEach(link => link.addEventListener('click', () => {
    const select = root.querySelector('[data-gift-select]');
    if (select) { select.value = link.dataset.gift; select.dispatchEvent(new Event('change', { bubbles: true })); }
  }));
}
document.querySelectorAll('.cg').forEach(initCorporateGifts);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.cg').forEach(initCorporateGifts));

  } catch(e) { console.error(e); }
})();
})();
